<template>
  <footer v-if="!isWebview">
    <div class="nav" role="navigation" aria-label="Main">
      <ul class="main-nav">
        <li v-for="route in mainNav" :key="route.label">
          <nuxt-link :to="localePath(route.url)">{{ $t(route.label) }}</nuxt-link>
        </li>
      </ul>
    </div>
    <ul class="social">
      <li>
        <a
          href="https://www.facebook.com/sohohouse"
          :title="$t('ALT_SOCIAL_FACEBOOK_LINK')"
        >{{ $t('ALT_SOCIAL_FACEBOOK_LABEL') }}</a>
      </li>
      <li>
        <a
          href="https://www.instagram.com/sohohouse"
          :title="$t('ALT_SOCIAL_INSTAGRAM_LINK')"
        >{{ $t('ALT_SOCIAL_INSTAGRAM_LABEL') }}</a>
      </li>
      <li>
        <a
          href="https://twitter.com/SohoHouse"
          :title="$t('ALT_SOCIAL_TWITTER_LINK')"
        >{{ $t('ALT_SOCIAL_TWITTER_LABEL') }}</a>
      </li>
    </ul>
    <p>{{ $t('FOOTER_COMPANY_NAME') }} {{ currentYear }}</p>
  </footer>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { decorators } from '@sohohouse/platform-resources'

const DateTime = decorators.shared.DateTime
const { mapGetters } = createNamespacedHelpers('ui/environment')

export default {
  data () {
    return {
      mainNav: [
        {
          label: 'FOOTER_NAV_CONTACT_HOUSE',
          url: { name: 'contact' }
        },
        {
          label: 'FOOTER_NAV_CONTACT_US',
          url: { name: 'contact' }
        },
        {
          label: 'FOOTER_NAV_FAQ',
          url: { name: 'faqs' }
        },
        {
          label: 'FOOTER_NAV_PRIVACY_POLICY',
          url: { name: 'policy-privacy' }
        },
        {
          label: 'FOOTER_NAV_HOUSE_RULES',
          url: { name: 'policy-house-rules' }
        },
        {
          label: 'FOOTER_NAV_COOKIE_POLICY',
          url: { name: 'policy-analytics' }
        },
        {
          label: 'FOOTER_NAV_TERMS',
          url: { name: 'terms' }
        },
        {
          label: 'FOOTER_NAV_U27_DISCOUNT',
          url: { name: 'discount' }
        }
      ],
      currentYear: new DateTime().year
    }
  },

  computed: {
    ...mapGetters(['isWebview'])
  }
}
</script>

<style lang="scss" scoped>
footer {
  width: 100%;
  bottom: 0;
  position: absolute;
  background-color: $color-white;
  color: $color-black;
  padding: $space-060 $space-050 0;

  @include font('040');
  @include breakpoint("medium") {
    padding: $space-060 $space-060 0;
  }

  > p {
    margin-bottom: $space-060;
  }

  a {
    text-decoration: none;
    color: $color-black;

    &:hover, &:active {
      text-decoration: underline;
    }
  }
}

ul {
  display: inline-flex;
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: $space-040;

    &:last-child {
      margin-right: 0;
    }
  }
}

.nav {
  width: 100%;
  display: inline-flex;
  margin-bottom: $space-080;

  @include breakpoint("medium") {
    margin-bottom: $space-060;
  }

  ul {
    width: 50%;
    display: block;

    li {
      margin-right: $space-060;

      &:last-child {
        margin-right: 0;
      }
    }

    @include breakpoint("medium") {
      &.main-nav {
        width: 100%;
      }

      li {
        display: inline-block;
        margin-bottom: unset;
      }
    }
  }
}

.social {
  display: block;
  margin-bottom: $space-080;

  li {
    margin-right: $space-060;
  }

  @include breakpoint("medium") {
    li {
      display: inline-block;
      margin-bottom: unset;
    }
  }
}
</style>
